import { LuShieldCheck, LuNewspaper, PiBrowsersBold } from '../assets/icons/vander'
import work1 from '../assets/images/nft/800/1.jpg'
import work2 from '../assets/images/nft/800/2.jpg'
import work3 from '../assets/images/nft/800/3.jpg'
import work4 from '../assets/images/nft/800/4.jpg'
import work5 from '../assets/images/nft/800/5.jpg'
import work6 from '../assets/images/nft/800/6.jpg'
import work7 from '../assets/images/nft/800/7.jpg'
import work8 from '../assets/images/nft/800/8.jpg'
import work9 from '../assets/images/nft/800/9.jpg'
import work10 from '../assets/images/nft/800/10.jpg'
import work11 from '../assets/images/nft/800/11.jpg'
import work12 from '../assets/images/nft/800/12.jpg'

import nft1 from '../assets/images/nft/500/1.jpg'
import nft2 from '../assets/images/nft/500/2.jpg'
import nft3 from '../assets/images/nft/500/3.jpg'
import nft4 from '../assets/images/nft/500/4.jpg'
import nft5 from '../assets/images/nft/500/5.jpg'
import nft6 from '../assets/images/nft/500/6.jpg'
import nft7 from '../assets/images/nft/500/7.jpg'
import nft8 from '../assets/images/nft/500/8.jpg'
import nft9 from '../assets/images/nft/500/9.jpg'
import nft10 from '../assets/images/nft/500/10.jpg'

import nft01 from '../assets/images/nft/625/1.jpg'
import nft02 from '../assets/images/nft/625/2.jpg'
import nft03 from '../assets/images/nft/625/3.jpg'
import nft04 from '../assets/images/nft/625/4.jpg'
import nft05 from '../assets/images/nft/625/5.jpg'
import nft06 from '../assets/images/nft/625/6.jpg'
import nft07 from '../assets/images/nft/625/7.jpg'
import nft08 from '../assets/images/nft/625/8.jpg'
import nft09 from '../assets/images/nft/625/9.jpg'
import nft010 from '../assets/images/nft/625/10.jpg'

import client1 from '../assets/images/client/01.jpg'
import client2 from '../assets/images/client/02.jpg'
import client3 from '../assets/images/client/03.jpg'
import client4 from '../assets/images/client/04.jpg'
import client5 from '../assets/images/client/05.jpg'
import client6 from '../assets/images/client/06.jpg'
import client7 from '../assets/images/client/07.jpg'
import client8 from '../assets/images/client/08.jpg'

import creatorBg1 from '../assets/images/nft/creator-bg/1.jpg'
import creatorBg2 from '../assets/images/nft/creator-bg/2.jpg'
import creatorBg3 from '../assets/images/nft/creator-bg/3.jpg'
import creatorBg4 from '../assets/images/nft/creator-bg/4.jpg'
import creatorBg5 from '../assets/images/nft/creator-bg/5.jpg'
import creatorBg6 from '../assets/images/nft/creator-bg/6.jpg'
import creatorBg7 from '../assets/images/nft/creator-bg/7.jpg'
import creatorBg8 from '../assets/images/nft/creator-bg/8.jpg'

export const workData = [
    {
        id:1,
        image: work1,
        image2:nft01,
        image3:nft1,
        title:'The future of ETH',
        value: '0.75ETH',
        clientImg: client1,
        name: 'Jordan',
        like:'23',
        category:'recents',
    },
    {
        id:2,
        image: work2,
        image2:nft02,
        image3:nft2,
        title:'ETH never die',
        value: '0.75ETH',
        clientImg: client2,
        name: 'Sofia',
        like:'23',
        category:'free',
    },
    {
        id:3,
        image: work3,
        image2:nft03,
        image3:nft3,
        title:'Future coming soon',
        value: '0.75ETH',
        clientImg: client3,
        name: 'Cristina',
        like:'23',
        category:'top',
    },
    {
        id:4,
        image: work4,
        image2:nft04,
        image3:nft4,
        title:'Elon Musk silver coin',
        value: '0.75ETH',
        clientImg: client4,
        name: 'Jack',
        like:'23',
        category:'recents',
    },
    {
        id:5,
        image: work5,
        image2:nft05,
        image3:nft5,
        title:'Amazing digital art',
        value: '0.75ETH',
        clientImg: client5,
        name: 'Lilia',
        like:'23',
        category:'free',
    },
    {
        id:6,
        image: work6,
        image2:nft06,
        image3:nft6,
        title:'Ribbon Hunter',
        value: '0.75ETH',
        clientImg: client6,
        name: 'Anderson',
        like:'23',
        category:'top',
    },
    {
        id:7,
        image: work7,
        image2:nft07,
        image3:nft7,
        title:'Amazing digital art',
        value: '0.75ETH',
        clientImg: client7,
        name: 'Joe',
        like:'23',
        category:'recents',
    },
    {
        id:8,
        image: work8,
        image2:nft08,
        image3:nft8,
        title:'The future of ETH',
        value: '0.75ETH',
        clientImg: client8,
        name: 'John',
        like:'23',
        category:'free',
    },
    {
        id:9,
        image: work9,
        image2:nft09,
        image3:nft9,
        title:'The future of ETH',
        value: '0.75ETH',
        clientImg: client1,
        name: 'Jordan',
        like:'23',
        category:'top',
    },
    {
        id:10,
        image: work10,
        image2:nft010,
        image3:nft10,
        title:'The future of ETH',
        value: '0.75ETH',
        clientImg: client2,
        name: 'Lilia',
        like:'23',
        category:'free',
    },
]

export const creatorData = [
    {
        id:1,
        image:creatorBg1,
        client: client1,
        name:'Jordan Joo',
        tag:'@jordan_joo',
        followers:'657',
        badge:'nft-creator-primary'
    },
    {
        id:2,
        image:creatorBg2,
        client: client2,
        name:'Sofia Malik',
        tag:'@sofia_malik',
        followers:'657',
        badge:'nft-creator-success'
    },
    {
        id:3,
        image:creatorBg3,
        client: client3,
        name:'Cristina Murphy',
        tag:'@cristina_murphy',
        followers:'657',
        badge:'nft-creator-warning'
    },
    {
        id:4,
        image:creatorBg4,
        client: client4,
        name:'Jack Lili',
        tag:'@jack_lili',
        followers:'657',
        badge:'nft-creator-danger'
    },
    {
        id:5,
        image:creatorBg5,
        client: client5,
        name:'Lilia Moris',
        tag:'@lilia_moris',
        followers:'657',
        badge:'nft-creator-info'
    },
    {
        id:6,
        image:creatorBg6,
        client: client6,
        name:'Anderson',
        tag:'@anderson',
        followers:'657',
        badge:'nft-creator-primary'
    },
    {
        id:7,
        image:creatorBg7,
        client: client7,
        name:'Joe Moris',
        tag:'@joe_moris',
        followers:'657',
        badge:'nft-creator-success'
    },
    {
        id:8,
        image:creatorBg8,
        client: client8,
        name:'John Carter',
        tag:'@John Carter',
        followers:'657',
        badge:'nft-creator-warning'
    },
]
export const accordianData = [
    {
        id:1,
        title:'Frequently Asked Questions',
        desc:'Explore and learn more about everything from machine learning and global payments to  scaling your team.',
    },
    {
        id:2,
        title:'How does NFT work?',
        desc:'Explore and learn more about everything from machine learning and global payments to  scaling your team.',
    },
    {
        id:3,
        title:'Why should I trust you?',
        desc:'Explore and learn more about everything from machine learning and global payments to  scaling your team.',
    },
    {
        id:4,
        title:'What is exchange rate?',
        desc:'Explore and learn more about everything from machine learning and global payments to  scaling your team.',
    },
]
export const workTwo = [
    {
        id:1,
        image: nft1,
        title:'The future of ETH',
        value: '0.75ETH',
        clientImg: client1,
        name: 'Jordan',
        like:'23',
        category:'recents',
    },
    {
        id:2,
        image: nft2,
        title:'ETH never die',
        value: '0.75ETH',
        clientImg: client2,
        name: 'Sofia',
        like:'23',
        category:'free',
    },
    {
        id:3,
        image: nft3,
        title:'Future coming soon',
        value: '0.75ETH',
        clientImg: client3,
        name: 'Cristina',
        like:'23',
        category:'top',
    },
    {
        id:4,
        image: nft4,
        title:'Elon Musk silver coin',
        value: '0.75ETH',
        clientImg: client4,
        name: 'Jack',
        like:'23',
        category:'recents',
    },
    {
        id:5,
        image: nft5,
        title:'Amazing digital art',
        value: '0.75ETH',
        clientImg: client5,
        name: 'Lilia',
        like:'23',
        category:'free',
    },
    {
        id:6,
        image: nft6,
        title:'Ribbon Hunter',
        value: '0.75ETH',
        clientImg: client6,
        name: 'Anderson',
        like:'23',
        category:'top',
    },
    {
        id:7,
        image: nft7,
        title:'Amazing digital art',
        value: '0.75ETH',
        clientImg: client7,
        name: 'Joe',
        like:'23',
        category:'recents',
    },
    {
        id:8,
        image: nft8,
        title:'The future of ETH',
        value: '0.75ETH',
        clientImg: client8,
        name: 'John',
        like:'23',
        category:'free',
    },
    {
        id:9,
        image: nft9,
        title:'The future of ETH',
        value: '0.75ETH',
        clientImg: client1,
        name: 'Jordan',
        like:'23',
        category:'top',
    },
]
export const collectionData = [
    {
        id:1,
        image:work1,
        image2:work2,
        image3:work3,
        image4:work4,
        client:client1,
        title:'Collection #1',
        name:'Jordan',
        item: '25'
    },
    {
        id:2,
        image:work5,
        image2:work6,
        image3:work7,
        image4:work8,
        client:client2,
        title:'Collection #2',
        name:'Sofia',
        item: '25'
    },
    {
        id:3,
        image:work9,
        image2:work10,
        image3:work11,
        image4:work12,
        client:client3,
        title:'Collection #3',
        name:'Cristina',
        item: '25'
    },
    {
        id:4,
        image:work4,
        image2:work1,
        image3:work2,
        image4:work3,
        client:client4,
        title:'Collection #4',
        name:'Jack',
        item: '25'
    },
    {
        id:5,
        image:work8,
        image2:work5,
        image3:work6,
        image4:work7,
        client:client5,
        title:'Collection #5',
        name:'Lilia',
        item: '25'
    },
    {
        id:6,
        image:work12,
        image2:work9,
        image3:work10,
        image4:work11,
        client:client6,
        title:'Collection #6',
        name:'Anderson',
        item: '25'
    },
    {
        id:7,
        image:work3,
        image2:work1,
        image3:work2,
        image4:work4,
        client:client7,
        title:'Collection #7',
        name:'Joe',
        item: '25'
    },
    {
        id:8,
        image:work7,
        image2:work5,
        image3:work6,
        image4:work8,
        client:client8,
        title:'Collection #8',
        name:'John',
        item: '25'
    },
    {
        id:9,
        image:work11,
        image2:work9,
        image3:work10,
        image4:work12,
        client:client1,
        title:'Collection #9',
        name:'John',
        item: '25'
    },
]
export const aboutData = [
    {
        icon:LuShieldCheck,
        title: 'Secure storage',
        desc:'We store the vast majority of the digital assets in secure offline storage.' 
    },
    {
        icon:LuNewspaper,
        title: 'Protected by insurance',
        desc:'Cryptocurrency stored on our servers is covered by our insurance policy.' 
    },
    {
        icon:PiBrowsersBold,
        title: 'Industry best practices',
        desc:'Cryptor supports a variety of the most popular digital currencies.' 
    },
]
export const accordianTwo = [
    {
        id:1,
        title:'How does it work ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:2,
        title:'Do I need a designer to use Cryptor ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:3,
        title:'What do I need to do to start selling ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:4,
        title:'What happens when I receive an order ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
]
export const faqData = [
    {
        id:1,
        title:'What is NFT?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:2,
        title:'How does NFT work?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:3,
        title:'Why should I trust you?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:4,
        title:'What is exchange rate?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:1,
        title:'Why do I need to enter my email?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:2,
        title:'What is the 2-factor authentication?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:3,
        title:'What should I do if I lose a device with 2FA authentication?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:4,
        title:'What happens when I receive an order ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:1,
        title:'What’s a wallet address?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:2,
        title:'How do I get a wallet address?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:3,
        title:'Whats the recipient’s address?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:4,
        title:'What is the maximal/minimal amount?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:1,
        title:'Which currencies are accepted for crypto-to-fiat transactions?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:2,
        title:'What limits are set for this transaction type?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:3,
        title:'What is SEPA bank transfer?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:4,
        title:'Which countries support crypto-to-fiat transactions?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
]